module.exports = __webpack_public_path__ + "static/media/play-icon.ed58d1cb.svg";